/** @mui/material imports */
/** @mui/icons-material imports */
/** React imports */
/** App imports */
import {
  DatasetMetadataType,
  DatasetUpload,
} from '../../TypeScript/interfaces';
import { JsonDataframe } from '../../TypeScript/types';
import { errorHandler } from '../../utils/error/error-handler';

/**
 * Injests a JsonDataframe using a webworker (to offload the task from the main process)
 * @param dataframe
 * @returns
 */
export const getInjestedDataframe = (
  dataframe: JsonDataframe,
): Promise<{ dataframe: JsonDataframe; metadata: DatasetMetadataType }> => {
  return new Promise((resolve, reject) => {
    /** send json to worker to be parsed */
    const worker = new Worker('/parse-dataframe-dataset.js');
    worker.onmessage = (message: MessageEvent<Omit<DatasetUpload, 'file'>>) => {
      const { dataset, columnHeaders, columnCount, rowCount, sample } =
        message.data;
      const response = {
        dataframe: dataset,
        metadata: {
          columnHeaders,
          columnCount,
          rowCount,
        },
      };
      worker.terminate();
      resolve(response);
    };
    worker.onerror = (error: ErrorEvent) => {
      worker.terminate();
      errorHandler(error.error);
      reject('ERROR_MESSAGE_FILE_NOT_TABULAR');
    };
    worker.postMessage(dataframe);
  });
};
